// extracted by mini-css-extract-plugin
module.exports = {"summary_header":"summary_header--dsF_V"};